import React, { useEffect, useMemo, useState } from "react";
import SRATable from "../SRATable";
import { Box, Button } from "@mui/material";
import ItemCount from "../../../../utils/ItemCount";
import axios from "axios";
import StatisticsPanel from "./StatisticsPanel";

const SuperuserDashboard = () => {
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "PENDING",
  );
  const [isLoading, setIsLoading] = useState(true);
  const [sras, setSras] = useState();
  const [pendingCount, setPendingCount] = useState();
  const [formType, setFormType] = useState(
    JSON.parse(localStorage.getItem("formType")) || "ALL",
  );

  useEffect(() => {
    const getPendingCount = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/all-forms/count-all?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
        );
        setPendingCount(res.data);
      } catch (error) {
        console.log(error);
      }
    };
    getPendingCount();
  }, [activeTab]);

  useEffect(() => {
    if (activeTab === "DELETED") {
      const getSRAs = async () => {
        setSras();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/all-forms/all/disable?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSras(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getSRAs();
    } else {
      const getSRAs = async () => {
        setSras();
        try {
          const res = await axios.get(
            `${process.env.REACT_APP_BACKEND_URL}/all-forms/all?username=${storedUser.username}`,
            { headers: { Authorization: `Bearer ${storedUser.accessToken}` } },
          );
          setSras(res.data);
          setIsLoading(false);
        } catch (error) {
          console.log(error);
        }
      };
      getSRAs();
    }
  }, [activeTab]);

  const getFormName = (formId, writeType) => {
    if (formId.includes("SO")) return "SERVICE";
    if (formId.includes("IA")) return "INVOICE";
    if (formId.includes("CA")) return "CUSTOMER";
    if (formId.includes("VA")) return "VENDOR_APPROVAL";
    if (formId.includes("TM")) return "TRADE";
    if (formId.includes("VAD")) return "VENDOR_ADVANCE";
    if (formId.includes("CD")) return "CUSTOMER_DEPOSIT";
    if (formId.includes("TD")) return "TENDER_DEPOSIT";
    if (formId.includes("WOVB") && writeType === "Off") return "VENDOR-Off";
    if (formId.includes("WOCB") && writeType === "Off")
      return "CUSTOMER_BALANCE-Off";
    if (formId.includes("WOAG") && writeType === "Off") return "ADVANCE-Off";
    if (formId.includes("WODG") && writeType === "Off") return "DEPOSIT-Off";
    if (formId.includes("WOI") && writeType === "Off") return "INVENTORY-Off";
    if (formId.includes("WOO") && writeType === "Off") return "OTHER-Off";
    if (formId.includes("WBVB") && writeType === "Back") return "VENDOR-Back";
    if (formId.includes("WBCB") && writeType === "Back")
      return "CUSTOMER_BALANCE-Back";
    if (formId.includes("WBAG") && writeType === "Back") return "ADVANCE-Back";
    if (formId.includes("WBDG") && writeType === "Back") return "DEPOSIT-Back";
    if (formId.includes("WBI") && writeType === "Back") return "INVENTORY-Back";
    if (formId.includes("WBO") && writeType === "Back") return "OTHER-Back";

    return null;
  };

  const filtered = useMemo(() => {
    let data = sras;

    // Form type filter
    if (formType !== "ALL") {
      data = data?.filter(
        (item) => getFormName(item.id, item.writeType) === formType,
      );
    }

    return data;
  }, [formType, sras, isLoading]);

  return (
    <Box sx={{ textAlign: "center" }}>
      <Box className="dashboard-container" sx={{ height: 400, width: "100%" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            mb: 2,
            borderBottom: "1px solid #D1D1D1",
          }}
        >
          <Box
            sx={{
              display: "flex",
              gap: 1,
            }}
          >
            <Button
              className={`dashboard-btns ${
                activeTab === "PENDING" ? "active" : ""
              }`}
              onClick={() => {
                setActiveTab("PENDING");
                setIsLoading(true);
                localStorage.setItem("activeTab", "PENDING");
              }}
            >
              All forms
              <ItemCount count={pendingCount} />
            </Button>
            {!storedUser.userRole?.includes("ADMIN") && (
              <Button
                className={`dashboard-btns ${
                  activeTab === "STATS" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("STATS");
                  setIsLoading(true);
                  localStorage.setItem("activeTab", "STATS");
                }}
              >
                Statistics
              </Button>
            )}
            {storedUser.userRole?.includes("ADMIN") && (
              <Button
                className={`dashboard-btns ${
                  activeTab === "DELETED" ? "active" : ""
                }`}
                onClick={() => {
                  setActiveTab("DELETED");
                  setIsLoading(true);
                  localStorage.setItem("activeTab", "DELETED");
                }}
              >
                Deleted
              </Button>
            )}
          </Box>
        </Box>
        {(activeTab === "PENDING" || activeTab === "DELETED") && (
          <>
            <div
              style={{ width: "100%", display: "flex", justifyContent: "end" }}
            >
              <div style={{ width: "30%" }}>
                <label htmlFor="">Form Name</label>
                <select
                  value={formType}
                  onChange={(e) => {
                    setFormType(e.target.value);
                    localStorage.setItem(
                      "formType",
                      JSON.stringify(e.target.value),
                    );
                  }}
                >
                  <option value="ALL">All</option>
                  <option value="SERVICE">Service Order Approval</option>
                  <option value="INVOICE">Invoice Approval</option>
                  <option value="CUSTOMER">New Customer Approval</option>
                  <option value="VENDOR_APPROVAL">New Vendor Approval</option>
                  <option value="TRADE">Trade Marketing Scheme</option>
                  <option value="VENDOR_ADVANCE">Vendor Advance</option>
                  <option value="CUSTOMER_DEPOSIT">Customer Deposit</option>
                  <option value="TENDER_DEPOSIT">Tender Deposit</option>
                  <option value="VENDOR-Off">
                    Write Off - Vendor Balances
                  </option>
                  <option value="CUSTOMER_BALANCE-Off">
                    Write Off - Customer Balances
                  </option>
                  <option value="ADVANCE-Off">
                    Write Off - Advances Given
                  </option>
                  <option value="DEPOSIT-Off">Write Off - Deposit Given</option>
                  <option value="INVENTORY-Off">Write Off - Inventory</option>
                  <option value="OTHER-Off">Write Off - Others</option>

                  <option value="VENDOR-Back">
                    Write Back - Vendor Balances
                  </option>
                  <option value="CUSTOMER_BALANCE-Back">
                    Write Back - Customer Balances
                  </option>
                  <option value="ADVANCE-Back">
                    Write Back - Advances Given
                  </option>
                  <option value="DEPOSIT-Back">
                    Write Back - Deposit Given
                  </option>
                  <option value="INVENTORY-Back">Write Back - Inventory</option>
                  <option value="OTHER-Back">Write Back - Others</option>
                </select>
              </div>
            </div>
            <SRATable
              sras={filtered}
              setSras={setSras}
              activeTab={activeTab}
              isLoading={isLoading}
            />
          </>
        )}
        {activeTab === "STATS" && <StatisticsPanel sras={sras || []} />}
      </Box>
    </Box>
  );
};

export default SuperuserDashboard;
